import BaseValidator from '~/composer/composer/lib/validation/BaseValidator';
import ValidationFail from '~/composer/composer/lib/validation/ValidationFail';
import ValidationResult from '~/composer/composer/lib/validation/ValidationResult';
import ValidationSuccess from '~/composer/composer/lib/validation/ValidationSuccess';
import {
  YT_MAX_CHAR_TITLE,
  YT_MISSING_TITLE,
  YT_TITLE_FORBIDDEN_CHARACTERS,
} from '~/composer/composer/lib/validation/utils/validationErrorMessages';

export default class YoutubeValidator extends BaseValidator {
  protected validateTitle() {
    const youtubeData = this.draft.channelData?.youtube;

    if (!youtubeData?.title) {
      return new ValidationFail(YT_MISSING_TITLE);
    }

    if (youtubeData?.title.length > 100) {
      return new ValidationFail(YT_MAX_CHAR_TITLE);
    }

    if (youtubeData?.title.includes('<') || youtubeData?.title.includes('>')) {
      return new ValidationFail(YT_TITLE_FORBIDDEN_CHARACTERS);
    }
    return new ValidationSuccess();
  }

  protected validateForChannel(): ValidationResult[] {
    return [this.validateTitle()];
  }
}
